import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// Application-wide DockRail mode. Entered via ?mode=dockrail, the Start Screen
// "Start DockRail" flow, or by opening a saved project with projectType='dock'.
// In dock mode the visualizer builds docks: only the DockRail railing family is
// available and deck-only features (tiers, stairs, walls, doors, awnings) are
// hidden. Persisted through the existing projectType field ('dock').
@Injectable()
export class DockModeService {
  static readonly PROJECT_TYPE = 'dock';
  static readonly URL_PARAM_VALUE = 'dockrail';

  private _dockMode = false;
  readonly modeChanged = new Subject<boolean>();

  isDockMode(): boolean {
    return this._dockMode;
  }

  setDockMode(value: boolean): void {
    if (this._dockMode !== value) {
      this._dockMode = value;
      this.modeChanged.next(value);
    }
  }

  setDockModeFromProjectType(projectType: string): void {
    this.setDockMode(projectType === DockModeService.PROJECT_TYPE);
  }

  // Lightweight deck/dock wording switch (the app has no i18n layer).
  copy(deckText: string, dockText: string): string {
    return this._dockMode ? dockText : deckText;
  }

  // Convenience for the most common substitution.
  surfaceName(): string {
    return this._dockMode ? 'dock' : 'deck';
  }
}



// WEBPACK FOOTER //
// ./src/app/services/dock-mode.service.ts